// This file is generated by a script. Do not edit this file directly.
var _excluded = ["className", "icon", "label", "size"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import { Icon } from "../Icon";
import { cva } from 'cva';
import { BaseButton } from "./Base";
import { cn } from "../../common/utils";
var iconButtonVariants = cva({
  variants: {
    size: {
      sm: 'cop-p-[5px]',
      base: 'cop-p-[7px]'
    }
  },
  defaultVariants: {
    size: 'base'
  }
});

// functionally the same as Omit<BaseButtonProps, 'children'>
// we're using this instead because Omit breaks in the build

export var IconButton = function IconButton(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    label = _ref.label,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseButton, _extends({
    className: cn(iconButtonVariants({
      size: size
    }), className),
    "aria-label": label !== null && label !== void 0 ? label : props['aria-label']
  }, props), /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "cop-h-4 cop-w-4"
  }));
};
